import { combineReducers } from 'redux';
import { orderBy } from 'lodash';

const filterReducer = (state = {}, action) => {
  switch(action.type){
    case "UPDATE_FILTER":
    return {
      ...state,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    }
    default:
      return state
  }
}

const calendarReducer = (state = [], action) => {
  switch (action.type) {
    case "START_FETCHING_EVENTS":
      var updatedCalendar = {
        ...state.filter(calendar => calendar.id == action.payload.calendar.id)[0], 
        isLoading: true 
      }
      return(
        [
          ...state.filter(calendar => calendar.id != action.payload.calendar.id),
          updatedCalendar
        ]
      ); 
      return state
    case "FETCH_EVENTS":
      var updatedCalendar = {
        ...state.filter(calendar => calendar.id == action.payload.calendar.id)[0], 
        events: action.payload.events, isLoading: false 
      }
      return(
        [
          ...state.filter(calendar => calendar.id != action.payload.calendar.id),
          updatedCalendar
          // leaving it like this right now to replace all the events, but in the future, i think we should only update the events that fall into the filter section that was updated. this can be done by also passing the start/end filter in the payload. We can keep all the events that don't fall in the filter range. the ones that do fall in the range, we replace with the payload.events, but eveything else would stay the same.
        ]
      ); 
      return state
    case "TOGGLE_CALENDAR_VISIBILITY":
      return orderBy(
        [
          ...state.filter(calendar => calendar.id != action.payload.calendar.id),
          { ...action.payload.calendar, visible: !action.payload.calendar.visible }
        ], (calendar) => { return calendar.id }, ['asc']
      ); 
    default:
      return state;
  }
}

export default combineReducers({
  filter: filterReducer,
  calendars: calendarReducer,
  current_user: (state = {}) => state,
  invitations: (state = {}) => state,
  organization: (state ={}) => state,
});
